export default {
  grey1: "#333333",
  grey2: "#4F4F4F",
  grey3: "#828282",
  grey4: "#BDBDBD",
  grey5: "#E0E0E0",
  grey6: "#F2F2F2",
  grey7: "#444444",
  grey8: "#E5E5E5",
  grey9: "#757575",
  grey10: "#818184",
  gray100: "#F2F4F8",
  gray300: "#d0d5dd",
  gray900: "#101828",
  gray500: "#667085",
  white: "#ffffff",
  ice: "#F9FAFB",
  warning: "#EB5757",
  check: "#00C896",
  unCheck: "#BDBDBD",
  background: "#E5E5E5",
  darkgrey: "#919CAB",
  blue: "#6587FF",
  black: "#424248",
  greenButton: "#6FCF97",
  almostBlack: "#46505A",
  error: "#F43636",
  fullBlack: "#000000",

  // PALETA DE CORES ORIGINAL
  primary: "#2D5BFF",
  Primaryv1: "#5277FA",
  Primaryv2: "#7793F5",
  Primaryv3: "#9BADEF",
  Primaryv4: "#C0C9EA",
  Primaryv5: "#D2D8E8",
  Secondary: "#02DE7F",
  Secondaryv1: "#30E094",
  Secondaryv2: "#5DE1A8",
  Secondaryv3: "#8AE2BC",
  Secondaryv4: "#B7E3D0",
  Secondaryv5: "#D4E5DE",
  LigthGrey: "#D5D5D5",
  Black: "#424248",
  Almostblack: "#636368",
  Darkgrey: "#848487",
  Mediumgrey: "#A3A3A6",
  Lightgrey: "#C4C4C5",
  White: "#FFFFFF",
  Danger: "#F44336",
  Info: "#2196F3",
  Success: "#4CAF50",
  Warning: "#ED6C02",
  lightdanger: "#FBC9C9",
  Lightinfo: "#D1E0ED",
  Lightsuccess: "#D1F2D1",
  Lightwarning: "#FFEAAC",
  VivazBlack: "#646363",
  Ping: "#F3F4F8",
  TextSideBard: "#666666",
  GreyCheck: "#C6CCD7",
  Primary50: "#eaefff",
  cardBorder: "#ececec",
};
